import React, { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context'
import Viewbanner from '../../Admin/components/View_banner';
import Addbanner from '../../Admin/components/Add_banner'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Deletepopup from '../components/Delete_popup'


const Banners = () => {
  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Name", field: "name", },
    { label: "Banner Image", field: "Bannerimage", },
    { label: "Status", field: "CommonStatus", },
    { label: "Created Date", field: "createddDate", },
    { label: "Last Updated Date", field: "UpdatedDate", },
    { label: "Actions", field: "action", }
  ];

  const title = { name: "Banners", subheading: "Verify the banners you have uploaded", search: "Search banners", button: "Add Banner" }
  const { loading, setLoading } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { deleteDialog, setdeleteDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [banners, setBanners] = useState([]);
  const [getbanners, setGetbanners] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null)

  //fetch banners
  const fetchBanners = async () => {
    try {
      const response = await instance.get('/Banner/getBanners')
      const formatteddata = response?.data?.data?.map((banner, index) => ({
        sno: index + 1,
        name: banner?.name ? banner?.name : "---",
        Bannerimage: banner?.image ? banner?.image : "---",
        CommonStatus: banner?.status === true ? "Active" : "Inactive",
        createddDate: new Date(banner?.createdAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        UpdatedDate: new Date(banner?.updatedAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        bannerId: banner?._id ? banner?._id : "---",
      }))

      setBanners(formatteddata);
    }
    catch (error) {
      console.log("error to fetch admins:", error.message)
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchBanners()
    setGetbanners(false)
    setLoading(true);
  }, [getbanners])

  // Handle Row Click for Edit
  const handleEditClick = (banner) => {
    setSelectedBanner(banner); 
    setEdit(true); 
    setOpenDialog(true);
  };

  // Handle Row Click for view
  const handleViewClick = (banner) => {
    setSelectedBanner(banner); 
    setopenviewDialog(true)
  }
  // Handle Row Click for Edit
  const handleDeleteClick = (banner) => {
    setSelectedBanner(banner); 
    setdeleteDialog(true);
  };


  return (
    <div>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          search={'banners'}
          title={title}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
        />
        <SubHeader
          menu={false}
          filter={false}
          openDialog={openDialog}
          setopenviewDialog={setopenviewDialog}
          setOpenDialog={setOpenDialog}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            columns={columns}
            rows={banners}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            openviewDialog={openviewDialog}
            setopenviewDialog={setopenviewDialog}
            edit={edit}
            setEdit={setEdit}
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
            handleViewClick={handleViewClick}
            bannerdelete={true}
            banner={true}
            menu={true}
          />
        }
        <Viewbanner
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedBanner={selectedBanner}
        />

        <Addbanner
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedBanner={selectedBanner}
          setGetbanners={setGetbanners}
        />
        <Deletepopup
          deleteDialog={deleteDialog}
          setdeleteDialog={setdeleteDialog}
          selectedBanner={selectedBanner}
          setGetbanners={setGetbanners}
        />
      </section>
    </div>
  )
}

export default Banners
